import { SxProps } from '@mui/material';
import { primary } from '@/theme/colors';

export const paperStyles: SxProps = {
  borderRadius: '0.8rem',
  maxWidth: '80%',
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1.6rem',
  typography: 'h4',
};

export const contentStyles = {
  padding: '2.4rem',
  paddingTop: '2.4rem !important',
};

export const radioButtonStyles = {
  width: '100%',
  '& .MuiSvgIcon-root': {
    color: primary.LightBlue,
  },
};

const commonButtonStyles: SxProps = {
  borderRadius: '4px',
  textTransform: 'none',
  '@media (max-width: 1728px)': {
    height: '32px',
    padding: '0',
  },
};

export const saveCancelButtonCommonStyles = {
  sx: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    mt: '10px',
    padding: '16px',
    gap: '16px',
    backgroundColor: 'white',
    textTransform: 'none',
  },
  saveButtonStyles: {
    ...commonButtonStyles,
    width: '60%',
  },
  cancelButtonStyles: {
    ...commonButtonStyles,
    width: '40%',
  },
};
